export var isKeyboardEvent = function isKeyboardEvent(event) {
  return event.key !== undefined;
};
export var isSelected = function isSelected(selected, item) {
  var _selected$find;

  return selected && !!((_selected$find = selected.find(function (_ref) {
    var value = _ref.value;
    return value === item.value;
  })) !== null && _selected$find !== void 0 && _selected$find.label);
};